export enum Subject {
	MATH = "math",
	LANGUAGE_ARTS = "language_arts",
	SCIENCE = "science",
	COMPUTER_SCIENCE = "computer_science",
}

export const subjectNames = {
	[Subject.MATH]: "Math",
	[Subject.LANGUAGE_ARTS]: "Language Arts",
	[Subject.SCIENCE]: "Science",
	[Subject.COMPUTER_SCIENCE]: "Computer Science",
};

export enum CourseCategory {
	MATH = Subject.MATH,
	LANGUAGE_ARTS = Subject.LANGUAGE_ARTS,
	SCIENCE = Subject.SCIENCE,
	COMPUTER_SCIENCE = Subject.COMPUTER_SCIENCE,
	SUMMER = "summer",
}

export const courseCategoryNames = {
	[CourseCategory.MATH]: "Math",
	[CourseCategory.LANGUAGE_ARTS]: "Language Arts",
	[CourseCategory.SCIENCE]: "Science",
	[CourseCategory.COMPUTER_SCIENCE]: "Computer Science",
	[CourseCategory.SUMMER]: "Summer",
};

export const subjectCategories = {
	[Subject.MATH]: CourseCategory.MATH,
	[Subject.LANGUAGE_ARTS]: CourseCategory.LANGUAGE_ARTS,
	[Subject.SCIENCE]: CourseCategory.SCIENCE,
	[Subject.COMPUTER_SCIENCE]: CourseCategory.COMPUTER_SCIENCE,
};

/**
 * Predicate function to check if a string is a valid Subject.
 */
export const checkIsValidSubject = (
	maybeSubject: string
): maybeSubject is Subject => {
	return (Object.values(Subject) as string[]).includes(maybeSubject);
};

/**
 * Convert a Subject to a CourseCategory if possible, return null otherwise
 *
 * @param Subject
 * @return CourseCategory | null
 */
export const safelyConvertSubjectToCategoryIfPossible = (subject: Subject) => {
	if ((Object.values(CourseCategory) as string[]).includes(subject)) {
		return subject as string as CourseCategory;
	}
	return null;
};

export interface SubjectAttributes {
	subjectId: Subject;
	subjectName: string;
	subjectURL: string;
}

export interface SubjectStrapi {
	data: {
		attributes: SubjectAttributes;
	};
}

export default Subject;
